import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlay} from '@fortawesome/free-solid-svg-icons';

import {getRecordValue} from 'Services/CmsHelpers';

export default class OnDemandItem extends React.Component {
	/**
     * @var state
     */
    state = {
    	preview: true,
    }

	/**
     * @method render
     * @return {JSX.Element}
     */
    render = () => {
    	const {item, useTopVideo, setTopVideo, renderItemBar, renderItemBody} = this.props;
    	const {preview} = this.state;

    	let item_thumbnail = getRecordValue(item, 'thumbnail', 'file');
        let speaker_name = getRecordValue(item, 'speaker_name');
        let speaker_name_2 = getRecordValue(item, 'speaker_name_2');
        let speaker_name_3 = getRecordValue(item, 'speaker_name_3');
        let speaker_name_4 = getRecordValue(item, 'speaker_name_4');
        let speaker_name_5 = getRecordValue(item, 'speaker_name_5');

        let job_title = getRecordValue(item, 'job_title');
        let job_title_2 = getRecordValue(item, 'job_title_2');
        let job_title_3 = getRecordValue(item, 'job_title_3');
        let job_title_4 = getRecordValue(item, 'job_title_4');
        let job_title_5 = getRecordValue(item, 'job_title_5');

        let item_title = getRecordValue(item, 'title');

        // Two-column layout: fixed-width video on the left, details on the right.
        return (
            <div className="ondemand-item flex flex-col md:flex-row bg-white shadow-sm mb-6">
                <div className="video-item flex rounded-sm overflow-hidden" key={item.id}>
                    {/* Left: video / thumbnail column (fixed width) */}
                    <div
                        className="video-thumb w-full md:w-96 flex-shrink-0 bg-gray-300 flex items-center justify-center cursor-pointer relative overflow-hidden"
                        onClick={()=> useTopVideo ? setTopVideo(item) : this.setState({preview: false})}
                    >
                        {preview &&
                            <>
                                {!item_thumbnail &&
                                    <div className="h-32 w-full flex justify-center items-center">
                                        <FontAwesomeIcon icon={faPlay} size="2x" className="h-24 w-24 text-app-blue" />
                                    </div>
                                }
                                {item_thumbnail &&
                                    <div className="relative w-full h-64">
                                        <img src={item_thumbnail} alt={item_title || 'thumbnail'} className="h-64 w-full object-cover" />
                                        {/* Play overlay - match dashboard styles (semi-opaque dark circle + white play icon) */}
                                        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                            <div className="bg-black bg-opacity-50 rounded-full py-2 px-6">
                                                <FontAwesomeIcon icon={faPlay} className="text-white" />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>
                        }

                        {!preview &&
                            <div className="h-32 w-full">
                                {renderItemBody(item)}
                            </div>
                        }
                    </div>
                </div>

                {/* Right: details column */}
                <div className="p-3 flex flex-col justify-between flex-1 text-left">
                    <div>
                        {item_title &&
                            <div className="text-app-blue font-bold mb-2">
                                {item_title}
                            </div>
                        }

                        {speaker_name &&
                            <div className="text-sm font-semibold">
                                {speaker_name}
                                {job_title && <div className="text-xs font-normal">{job_title}</div>}
                            </div>
                        }

                        {speaker_name_2 &&
                            <div className="text-sm font-semibold mt-2">
                                {speaker_name_2}
                                {job_title_2 && <div className="text-xs font-normal">{job_title_2}</div>}
                            </div>
                        }

                        {speaker_name_3 &&
                            <div className="text-sm font-semibold mt-2">
                                {speaker_name_3}
                                {job_title_3 && <div className="text-xs font-normal">{job_title_3}</div>}
                            </div>
                        }

                        {speaker_name_4 &&
                            <div className="text-sm font-semibold mt-2">
                                {speaker_name_4}
                                {job_title_4 && <div className="text-xs font-normal">{job_title_4}</div>}
                            </div>
                        }

                        {speaker_name_5 &&
                            <div className="text-sm font-semibold mt-2">
                                {speaker_name_5}
                                {job_title_5 && <div className="text-xs font-normal">{job_title_5}</div>}
                            </div>
                        }
                    </div>

                    {/* Item bar (download / likes / comments) */}
                    <div className="mt-3">
                        {renderItemBar(item)}
                    </div>
                </div>
            </div>
        );
    };
}
